export default __webpack_public_path__ + "static/media/AppleStoreIco.ef9bfda2.svg";